import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTenant } from '../contexts/TenantContext';

export default function MigrationWarningBanner() {
  const { t } = useTranslation();
  const { migrationStatus } = useTenant();

  // Test runs `dev` = main + every open PR, so two PRs each carrying a migration leave the
  // database on two legitimate heads (deploy-test.sh applies them with `alembic upgrade heads`).
  // /migration_status compares a single current revision against a single expected head, so it
  // reports a mismatch even though every migration is applied — a false alarm on that box only.
  if (import.meta.env.VITE_DISABLE_MIGRATION_WARNING === 'true') {
    return null;
  }

  // Don't show if not checked yet or if database is up to date
  if (!migrationStatus?.checked || migrationStatus?.isUpToDate) {
    return null;
  }

  return (
    <Alert severity="warning" variant="filled" sx={{ borderRadius: 0 }}>
      <AlertTitle>{t('migration.warning_title')}</AlertTitle>
      {t('migration.warning_message')}
    </Alert>
  );
}
